export default "__VITE_ASSET__BubvfsIS__"